import React, { useState } from 'react';
import { Box, Card, CardContent, Tab, Tabs } from '@mui/material';
import GeneralConfig from './generalConfig';
import PrescriptionTemplate from './prescriptionTemplate';

const TAB_CONFIGS = [
  { key: 'general', label: 'Gerais', component: GeneralConfig },
  {
    key: 'prescription-template',
    label: 'Template para Receituário',
    component: PrescriptionTemplate,
  },
];

export default function GeneralSettings() {
  const [currentTabKey, setCurrentTabKey] = useState('general');

  const activeTab = TAB_CONFIGS.find((t) => t.key === currentTabKey) ?? TAB_CONFIGS[0];
  const ActiveComponent = activeTab.component;

  return (
    <Card>
      <Tabs
        value={currentTabKey}
        onChange={(_, key) => setCurrentTabKey(key)}
        sx={{ px: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        {TAB_CONFIGS.map((tab) => (
          <Tab
            key={tab.key}
            value={tab.key}
            label={tab.label}
            sx={{ fontSize: '0.8rem', paddingY: 1 }}
          />
        ))}
      </Tabs>
      <CardContent>
        <Box>
          <ActiveComponent />
        </Box>
      </CardContent>
    </Card>
  );
}
